<template>
  <div>
    <!-- 我的订单 -->
    <form action="" class="w-100 layui-form" method="post">
      <div class="user-info3 w-100 between-center">
        <!-- <el-date-picker
          v-model="date"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="——"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <el-select v-model="stateValue" clearable placeholder="订单状态">
          <el-option
            v-for="item in orderState"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input placeholder="订单编号" v-model="suid"></el-input>
      </div>
      <div
        class="user-info3 w-100 between-center"
        style="justify-content: flex-end"
      >
        <!-- <el-input placeholder="产品名称" v-model="proName"></el-input> -->
        <div class="btns">
          <input
            type="button"
            class="layui-btn layui-btn-normal"
            name=""
            id=""
            value="确定"
            @click="init"
          />
          <input
            type="reset"
            class="layui-btn"
            name=""
            id=""
            value="重置"
            @click="reset"
          />
        </div>
      </div>
    </form>
    <div
      class="no-content"
      style="display: flex; justify-content: center; width: 100%"
      v-if="orderList.length == 0"
    >
      <img src="/static/img/no_data5.png" />
    </div>
    <el-table
      v-tableDrag
      :header-cell-style="thStyleFun"
      :cell-style="cellStyleFun"
      :data="orderList"
      style="width: 100%"
      v-loading="loading"
      ref="partUpdate"
      v-else
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table
            :header-cell-style="thStyleFun"
            :cell-style="cellStyleFun"
            :data="scope.row.orderGoods"
            style="width: 100%"
            class="tempTable"
          >
            <el-table-column
              fixed="left"
              prop=""
              label=""
              width="50"
            ></el-table-column>
            <el-table-column prop="goodsCoverUrl" label="商品封面" width="200">
              <template slot-scope="scope">
                <img
                  style="width: 4rem"
                  :src="scope.row.goodsCoverUrl"
                  alt=""
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="goodsName"
              label="商品名称"
              width="300"
            />
            <el-table-column width="auto" prop="specDetail" label="型号" >
              <template slot-scope="scope">
                {{ scope.row.specDetail }}
              </template>
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="数量"
              width="100"
            />

          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        label="订单编号"
        prop="uid"
        width="300"
      ></el-table-column>
      <el-table-column
        label="数量"
        prop="goodsQty"
        width="100"
      ></el-table-column>
      <!-- <el-table-column
        label="金额"
        prop="totalAmt"
        width="100"
      ></el-table-column> -->
      <el-table-column label="状态" prop="state" width="200">
        <template slot-scope="scope">
          {{ setStatus(scope.row.state) }}
        </template>
      </el-table-column>
      <el-table-column
        label="下单日期"
        prop="whenCreated"
        width="200"
      ></el-table-column>
      <el-table-column prop="" label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <!-- <el-button
            type="warning"
            size="small"
            round
            v-if="scope.row.state == 1"
            @click="payMent(scope.row)"
            >支付</el-button
          > -->
          <el-button
            type="info"
            size="small"
            round
            v-if="scope.row.state == 1"
            @click="cancelOrder(scope.row.uid)"
            >取消</el-button
          >
          <el-button
            type="danger"
            size="small"
            round
            v-if="
              scope.row.state == 10 ||
              scope.row.state == 60 ||
              scope.row.state == 65
            "
            @click="deleteData(scope.row.uid)"
            >删除</el-button
          >
          <el-button
            type="info"
            size="small"
            round
            @click="orderDetail(scope.row)"
            >查看详情</el-button
          >
          <!-- <el-button
            v-if="scope.row.state == 80"
            type="success"
            size="small"
            round
            @click="goOffLine(scope.row)"
            >提交支付证明</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <div
      class="user-info4 w-100 between-center"
      style="justify-content: center"
      v-if="orderList.length != 0"
    >
      <div class="fanye gray">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalPage"
          :page-size="pageSize"
          @current-change="currentChange"
          @prev-click="prevClick"
          @next-click="nextClick"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  orderCancel,
  aftersaleApply,
  orderStore,
  orderDelete
} from '@/common/http.js';
import {
  message
} from '@/common/common.js';
import { setStatus } from '../../utils/orderStatus';
export default {
  data () {
    return {
      loading: true,
      orderList: [],
      totalPage: 0,
      pageSize: 8,
      pageIndex: 1,
      active: 0,
      orderState: [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '跟进中'
      }, {
        value: '10',
        label: '待收货'
      }, {
        value: '15',
        label: '已收货'
      }],
      stateValue: '',
      spit: '',
      date: '',
      suid: '',
      proName: '',
    }
  },
  mounted () {
    this.$emit('change_bread', 0);
    if (this.$route.query.data) {
      this.stateValue = this.$route.query.data
    }
    this.init();
  },
  methods: {
    goOffLine (row) {

      const orderMsg = {
        order: {
          serialNumber: row.uid,
          whenCreated: row.whenCreated,
          totalPrice: row.orderGateway.payAmt,
        },
        contacter: row.orderExt.receiverName,
        contactPhone: row.orderExt.receiverPhone,
        receiverAddress: row.orderExt.addressDetail,
        creatOrderStoreGoods: row.orderGoods,
        id: row.id
      }
      this.$router.push({
        path: '/offLinePay',
        name: 'offLinePay',
        query: {
          data: orderMsg
        }
      })
    },
    setStatus (status) {
      return setStatus(status);
    },
    init () {
      this.loading = true;
      // let datestr = '';
      // if (this.date) {
      //   datestr = this.date[0] + ',' + this.date[1] + ' 23:59:59'
      // }
      orderStore({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        uid: this.suid,
        startTime: this.date[0],
        endTime: this.date[1],
        state: this.stateValue,
      }).then(res => {
        if (res.result) {
          this.orderList = res.data.rows;
          this.totalPage = res.data.total;
        }
        this.loading = false;
      })
    },
    thStyleFun () {
      return 'text-align:center'
    },
    cellStyleFun () {
      return 'text-align:center'
    },
    currentChange (evt) {
      this.pageIndex = evt;
      this.init();
    },
    prevClick () {
      this.pageIndex -= 1;
      this.init();
    },
    nextClick () {
      this.pageIndex += 1;
      this.init();
    },
    // 重置
    reset () {
      this.stateValue = '';
      this.date = '';
      this.suid = '';
      this.proName = '';
      this.init();
    },
    // 退款
    afterSale (row) {
      let that = this;
      if (row.afterType != 1) {
        return
      }
      console.log(row.id)
      that.$prompt('请输入退款理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入退款理由'
      }).then(({
        value
      }) => {
        aftersaleApply({
          type: 1,
          info: value,
          gid: row.id
        }, 'post').then(res => {
          if (res.result) {
            message({
              message: '申请退款成功！',
              type: 'success'
            })
            that.$set(row, 'afterType', 5);
          } else {
            message({
              message: res.data.msg,
              type: 'waring'
            })
          }
        })
      }).catch(() => { });
    },
    // 取消订单
    cancelOrder (id) {
      this.$confirm('确定取消该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        orderCancel({
          uid: id
        }, 'get').then(res => {
          if (res.result) {
            message({
              message: '该订单已取消！',
              type: 'success'
            })
            this.init();
          } else {
            message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      }).catch(() => { });
    },
    deleteData (uid) {
      this.$confirm('确定删除该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        orderDelete({ uid }, 'delete').then(res => {
          if (res.result) {
            message({
              message: res.msg,
              type: 'success'
            })
            this.init();
          } else {
            message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        message({
          message: "已取消删除",
          type: 'info'
        })
      })
    },
    // 部分修改
    goUpdatePart () {
      this.$refs.partUpdate.validate(valid => {
        console.log(valid)
      })
    },
    // 支付
    payMent (row) {
      let data = {
        id: row.id,
        orderPay: true
      }
      this.$router.push({
        path: '/orderPayment',
        name: 'orderPayment',
        query: {
          obj: encodeURIComponent(JSON.stringify(data))
        }
      });
    },
    // 查看详情
    orderDetail (row) {
      this.$router.push({
        path: '/orderDetails',
        name: 'orderDetails',
        query: {
          uid: row.uid
        }
      });
    },
    search () {
      // sorderSearch({
      // 	orderNo:'',
      // 	datestr:'',
      // 	k:'',
      // })
    }
  }
}
</script>

<style scoped="scoped">
/deep/ .el-table td {
  color: #666;
}

/deep/ .el-table th > .cell {
  font-weight: 500;
  color: #000;
}

/deep/ .el-table__expanded-cell {
  padding: 0;
}

/deep/ .tempTable .cell {
  font-size: 13px;
}

.el-button--warning {
  background-color: rgb(255, 138, 43);
  border-color: rgb(255, 138, 43);
}

.el-button--info {
  background-color: rgb(180, 180, 180);
  border-color: rgb(180, 180, 180);
}

.el-select {
  width: 31.5%;
  height: 2.875rem;
  border-radius: 0.375rem;
}

.el-input {
  width: 31.5%;
  height: 2.875rem;
  border-radius: 0.375rem;
}

.el-range-editor.el-input__inner {
  width: 31.5%;
}
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/meOrder.vue